import React from 'react';
import { CostItem } from '../CostItem';
import * as S from './styled';
export const EstimatedProfit = ({ value, withSeparator = true }) => {
    return (React.createElement(S.Container, { "$withSeparator": withSeparator },
        React.createElement(CostItem, { name: "Estimated profit per unit sold", value: value, bold: true })));
};
